import styled, { css } from "styled-components";

export const Button = styled.button`
  width: 100%;
  padding: 1rem 2rem;
  border-radius: ${({ rounded }) => (rounded ? "999px" : "6px")};

  border: none;

  font-size: 1rem;

  cursor: pointer;

  &:focus-within {
    outline: 2px solid
      ${({ color }) =>
        color ? `${color.slice(0, 7)}77` : "var(--primary-color-opaque)"};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.8;
    cursor: default;
  }

  &:not(:disabled):hover {
    filter: brightness(0.95);
  }

  ${({ variant }) =>
    variant === "secondary"
      ? css`
          border: 2px solid ${({ color }) => color || "var(--primary-color)"};
          color: ${({ color }) => color || "var(--primary-color)"};
          background-color: transparent;
        `
      : css`
          color: white;
          background-color: ${({ color }) => color || "var(--primary-color)"};
        `}
`;
